// extracted by mini-css-extract-plugin
export default {"link":"BasketDetail_link__-3Cro","theme-grayscale":"BasketDetail_theme-grayscale__1wokN"};